import { create } from 'zustand';
import { MessageTypes } from '../core/enums';

export interface MessageDetails {
	message: string;
	type: MessageTypes;
}

interface MessageState {
	messageDetails: MessageDetails;
	updateMessage: (message: string, type?: MessageTypes) => void;
}

export const useMessageStore = create<MessageState>((set) => ({
	messageDetails: null,
	updateMessage: (message: string, type?: MessageTypes) =>
		set(() => ({ messageDetails: { message, type: type ?? MessageTypes.Error } }))
}));
